import React, { Component } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
// eslint-disable-next-line import/no-extraneous-dependencies
import get from 'lodash/get';
import {
    withStyles,
    ListItem,
    ListItemText,
    ListItemIcon,
    IconButton,
    Grid,
    Typography,
    Button,
    List,
    ExpansionPanel,
    ExpansionPanelDetails,
    ExpansionPanelSummary,
    Chip,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import SettingsOutlined from '@material-ui/icons/SettingsOutlined';
import CancelPresentation from '@material-ui/icons/CancelPresentation';

import {
    updateDetailSettings,
    loadArticlesPickerScript,
} from 'Console/data/applicationDetail/settings/SettingsAction';

import {
    selectApplicationJourneyTracker,
    selectApplicationMetaData,
    selectApplicationSettings,
} from 'Console/data/applicationDetail/settings/SettingsSelector';

import FormSelect from 'Console/components/common/form/FormSelect';

import { selectConsoleLanguage } from 'Console/data/language/selectors';

import { initializePickerApi } from './pickerScript';

const styles = (theme) => ({
    root: {
        boxShadow: '0px 1px 0px rgba(0, 0, 0, 0.25)',
    },
    column: {
        flexBasis: '45%',
    },
    btnAdd: {
        marginTop: theme.spacing.unit + 7,
        marginLeft: theme.spacing.unit * 5 + 7,
        [theme.breakpoints.down('sm')]: {
            marginLeft: 0,
        },
    },
    listItems: {
        paddingTop: theme.typography.pxToRem(20),
        paddingBottom: theme.typography.pxToRem(20),
    },
    listItem: {
        padding: 0,
    },
    boxList: {
        width: '70%',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },
    chips: {
        textTransform: 'uppercase',
        display: 'flex',
        flexWrap: 'wrap',
        marginLeft: theme.typography.pxToRem(10),
        marginRight: theme.typography.pxToRem(10),
        width: '35%',
    },
    chip: {
        height: theme.typography.pxToRem(22),
        fontSize: theme.typography.pxToRem(9),
        marginRight: theme.typography.pxToRem(10),
        marginBottom: theme.typography.pxToRem(5),
        fontWeight: 600,
        letterSpacing: '0.0357143em',
    },
    itemsBox: {
        width: '70%',
    },
    details: {
        paddingTop: theme.typography.pxToRem(24),
    },
});

// TODO - add FormItemSelect component
// edit component "AricleExpansionPanel", becouse it is only for example

class ArticlesExpansionPanel extends Component {
    state = {
        isExpanded: false,
    };

    componentDidMount() {
        const { loadArticlesPickerScript } = this.props;
        const loadScript = function (src) {
            const tag = document.createElement('script');
            tag.async = false;
            tag.src = src;
            const body = document.getElementsByTagName('body')[0];
            body.appendChild(tag);
        };

        loadScript(`https://apis.google.com/js/api.js`);
        loadArticlesPickerScript();
    }

    handleAddItem = () => {
        const {
            form: { getFieldValue, setFieldsValue },
        } = this.props;
        const selectJourney = getFieldValue('selectJourney');
        const items = getFieldValue('selectedJourneyList');
        if (!selectJourney || items.includes(selectJourney)) {
            return;
        }

        setFieldsValue({
            selectedJourneyList: [...items, selectJourney],
            selectJourney: '',
        });
    };

    handleRemoveItem = (itemToRemove) => {
        const {
            form: { getFieldValue, setFieldsValue },
            updateDetailSettings,
            metadata,
        } = this.props;
        const items = getFieldValue('article.articles');

        setFieldsValue({
            'article.articles': items.filter((item) => item.id !== itemToRemove.id),
        });

        updateDetailSettings(
            {
                'metadata.contextHelp.articles': get(metadata, 'contextHelp.articles').filter(
                    (article) => article.payload.id !== itemToRemove.id
                ),
            },
            {
                success: (
                    <FormattedMessage id="Notification.save" defaultMessage="Your settings were saved" />
                ),

                fail: (
                    <FormattedMessage
                        id="Notification.fail"
                        defaultMessage="Unable to save, something went wrong"
                    />
                ),
            }
        );
    };

    handleSourceChange = (e) => {
        const { value } = e.target;
        if (value.id === 'google') {
            initializePickerApi({ pickerCallback: this.pickerCallback });
        }
    };

    onExpand = () => {
        const { isExpanded } = this.state;
        this.setState({
            isExpanded: !isExpanded,
        });
    };

    pickerCallback = (data) => {
        const {
            form: { setFieldsValue },
            updateDetailSettings,
            metadata,
        } = this.props;

        const prevArticles = get(metadata, 'contextHelp.articles') || [];
        if (data.action === window.google.picker.Action.PICKED) {
            setFieldsValue({
                'article.articles': [data.docs[0], ...prevArticles.map((article) => article.payload)],
            });

            updateDetailSettings(
                {
                    'metadata.contextHelp.articles': [
                        { payload: data.docs[0], addOn: 'yeself-google-drive' },
                        ...prevArticles,
                    ],
                },
                {
                    success: (
                        <FormattedMessage
                            id="Notification.save"
                            defaultMessage="Your settings were saved"
                        />
                    ),

                    fail: (
                        <FormattedMessage
                            id="Notification.fail"
                            defaultMessage="Unable to save, something went wrong"
                        />
                    ),
                }
            );
        }
    };

    render() {
        const {
            intl,
            classes,
            form: { getFieldValue, getFieldDecorator },
            form,
            metadata,
        } = this.props;

        const { isExpanded } = this.state;
        const metadataArticles = get(metadata, 'contextHelp.articles') || [];
        getFieldDecorator('article.articles', {
            initialValue: metadataArticles.map((article) => article.payload),
            preserve: true,
        });

        const articleSource = getFieldValue('article.source');

        return (
            <ExpansionPanel expanded={isExpanded} onChange={this.onExpand}>
                <ExpansionPanelSummary className={classes.root} expandIcon={<ExpandMoreIcon />}>
                    <div className={classes.column}>
                        <Typography variant="subtitle1">
                            <FormattedMessage
                                id="ContextHelp.expansionPanel.articles"
                                defaultMessage="Articles"
                            />
                        </Typography>
                    </div>
                </ExpansionPanelSummary>

                <ExpansionPanelDetails className={classes.details}>
                    <Grid item xs={12}>
                        <div id="result" />
                        <Grid
                            container
                            direction="row"
                            justify="space-between"
                            className={classes.itemsBox}
                        >
                            <Grid style={{ width: '20.5625rem' }}>
                                <FormSelect
                                    form={form}
                                    fullWidth
                                    isRequired
                                    formItemKey="article.source"
                                    label={intl.formatMessage({ id: 'ContextHelp.article.source' })}
                                    onChange={this.handleSourceChange}
                                    optionList={[
                                        {
                                            id: 'google',
                                            name: 'Google drive',
                                        },
                                    ]}
                                />
                            </Grid>

                            <Typography>
                                <Button
                                    id="yeself-button"
                                    variant="contained"
                                    color="primary"
                                    disabled={!articleSource || articleSource.id !== 'google'}
                                    onClick={this.handleAddItem}
                                    className={classes.btnAdd}
                                >
                                    <FormattedMessage id="Buttons.add" defaultMessage="Add" />
                                </Button>
                            </Typography>
                        </Grid>

                        <Grid item className={classes.boxList}>
                            <List className={classes.listItems}>
                                {getFieldValue('article.articles').map((article) => (
                                    <ListItem className={classes.listItem} key={article.id}>
                                        <ListItemText primary={article.name} />
                                        {article.type === 'folder' && (
                                            <Grid id="yeself-guide-rule-chips" className={classes.chips}>
                                                <Chip
                                                    color="secondary"
                                                    variant="default"
                                                    label="Google"
                                                />
                                            </Grid>
                                        )}
                                        <ListItemIcon>
                                            <IconButton aria-label="Settings">
                                                <SettingsOutlined />
                                            </IconButton>
                                        </ListItemIcon>

                                        <ListItemIcon>
                                            <IconButton
                                                aria-label="Delete"
                                                onClick={() => this.handleRemoveItem(article)}
                                            >
                                                <CancelPresentation />
                                            </IconButton>
                                        </ListItemIcon>
                                    </ListItem>
                                ))}
                            </List>
                        </Grid>
                    </Grid>
                </ExpansionPanelDetails>
            </ExpansionPanel>
        );
    }
}

export default connect(
    (state) => ({
        journeyTracker: selectApplicationJourneyTracker(state),
        currentLang: selectConsoleLanguage(state),
        metadata: selectApplicationMetaData(state),
        applicationSettings: selectApplicationSettings(state),
    }),
    { updateDetailSettings, loadArticlesPickerScript }
)(withStyles(styles)(injectIntl(ArticlesExpansionPanel)));
